import { type IMachine } from "@/interfaces/api/machine.interface"
import { BaseModel } from "@/models/base.model"

export class Machine extends BaseModel implements IMachine {
  public static className = "Machine" // Used for socket communication.
  public static verboseName = "machine"

  id?: string

  name: string

  constructor(machine: IMachine) {
    super(machine)

    this.id = machine.id
    this.name = machine.name
  }
}
